import React, { useState } from "react";

interface Props {
  titulo: string;
  nombreEsperado: string;
  advertencia?: string;
  onConfirmar: () => void;
  onCancelar: () => void;
}

// Modal de confirmación reforzada: hay que escribir el nombre exacto para habilitar el borrado.
// No reemplaza los permisos del backend, es solo una red de seguridad contra clicks accidentales.
export default function ConfirmarEliminacion({ titulo, nombreEsperado, advertencia, onConfirmar, onCancelar }: Props) {
  const [texto, setTexto] = useState("");
  const coincide = texto.trim() === nombreEsperado;

  return (
    <div style={styles.overlay} onClick={onCancelar}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        <div style={styles.titulo}>{titulo}</div>
        <div style={styles.texto}>
          Esta acción no se puede deshacer.
          {advertencia && <div style={styles.advertencia}>{advertencia}</div>}
        </div>
        <div style={styles.label}>
          Escribí <strong>{nombreEsperado}</strong> para confirmar:
        </div>
        <input
          style={styles.input}
          value={texto}
          onChange={e => setTexto(e.target.value)}
          autoFocus
          placeholder={nombreEsperado}
        />
        <div style={styles.botones}>
          <button style={styles.btnCancelar} onClick={onCancelar}>Cancelar</button>
          <button
            style={{ ...styles.btnEliminar, opacity: coincide ? 1 : 0.5, cursor: coincide ? "pointer" : "not-allowed" }}
            onClick={() => coincide && onConfirmar()}
            disabled={!coincide}
          >
            Eliminar definitivamente
          </button>
        </div>
      </div>
    </div>
  );
}

const styles: { [key: string]: React.CSSProperties } = {
  overlay: { position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 },
  modal: { backgroundColor: "#fff", borderRadius: 12, padding: 28, width: "100%", maxWidth: 380, boxShadow: "0 10px 40px rgba(0,0,0,0.2)" },
  titulo: { fontSize: 16, fontWeight: 700, color: "#1a1a2e", marginBottom: 10 },
  texto: { fontSize: 13, color: "#666", marginBottom: 14, lineHeight: 1.5 },
  advertencia: { marginTop: 6, color: "#e74c3c", fontSize: 12 },
  label: { fontSize: 12, color: "#333", marginBottom: 8 },
  input: { width: "100%", padding: "8px 10px", borderRadius: 8, border: "1px solid #ddd", fontSize: 13, boxSizing: "border-box" as const, outline: "none", marginBottom: 18 },
  botones: { display: "flex", gap: 8, justifyContent: "flex-end" },
  btnCancelar: { padding: "8px 16px", backgroundColor: "#f4f6f8", color: "#555", border: "1px solid #ddd", borderRadius: 8, fontSize: 13, cursor: "pointer" },
  btnEliminar: { padding: "8px 16px", backgroundColor: "#e74c3c", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 600 },
};
